import React, { useMemo, useRef, useState, useEffect } from "react";
import { /*Button,*/ Col, Row, Switch, Input, Tooltip, Select } from 'antd';
import axios from "axios";

import requestsIcon from '../../assets/images/dashboard/metrics/requests.svg';
// import clicksIcon from '../../assets/images/dashboard/metrics/clicks.svg';
import impressionsIcon from '../../assets/images/dashboard/metrics/impressions.svg';
import revenuesIcon from '../../assets/images/dashboard/metrics/revenue.svg';
import ecpmIcon from '../../assets/images/dashboard/metrics/ecpm.svg';
import ivtIcon from '../../assets/images/dashboard/metrics/ivt.svg';
import fillrateIcon from '../../assets/images/dashboard/metrics/fillrate.svg';
import arrowUpIcon from '../../assets/images/dashboard/metrics/arrow-up-right.svg';
// import sortArrowIcon from '../../assets/images/dashboard/sort-arrow.svg';
import arrowDownIcon from '../../assets/images/dashboard/metrics/arrow-down-left.svg';
import Chart from "react-apexcharts";
import errorDataImg from '../../assets/images/icons/performance_no_data.svg';
import nodataImgIVT from '../../assets/images/icons/Error_ivt_nodata.svg';
import nodataImg from '../../assets/images/icons/no_data_dashboard.svg';
// import dayjs from "dayjs";
import configData from "../../config/config.json";
import Cookies from "js-cookie";
import ContentLoader from 'react-content-loader'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment-timezone";
// import ApexCharts from "apexcharts";
import publisherIcon from '../../assets/images/dashboard/briefcase.svg';
import ctvIcon from '../../assets/images/dashboard/ctv.svg';
import linkIcon from '../../assets/images/dashboard/link.svg';
import zoneIcon from '../../assets/images/dashboard/zone.svg';
import gridIcon from '../../assets/images/dashboard/grid.svg';
// import { Link } from "react-router-dom";


function DashboardV2Main(props) {
    //---------------------datepicker related code ---------------------------------//
    // All date logic is driven by PST timezone (America/Los_Angeles handles DST automatically)
    // e.g. if user is in India and local date is 25th but PST date is still 24th,
    // "Today" in the picker will show 24th and 25th will be disabled/unreachable.
    const pstToday = moment().tz("America/Los_Angeles").startOf('day');
    const pstYesterday = pstToday.clone().subtract(1, 'days');

    const [dateRange, setDateRange] = useState({
        start: pstToday.clone().subtract(6, "days"),
        end: pstToday.clone(),
    });
    const pickerRef = useRef(null);
    const [active, setActive] = useState("7D");

    const ranges = {
        Today: [pstToday.clone(), pstToday.clone()],
        Yesterday: [pstYesterday.clone(), pstYesterday.clone()],
        "7D": [pstToday.clone().subtract(6, "days"), pstToday.clone()],
        "30D": [pstToday.clone().subtract(29, "days"), pstToday.clone()],
        // "3M": [moment().subtract(3, "months"), moment()]
    };

    const handlePresetClick = (label) => {
        // Re-compute fresh PST ranges at click time
        const freshPstToday = moment().tz("America/Los_Angeles").startOf('day');
        const freshPstYesterday = freshPstToday.clone().subtract(1, 'days');

        const freshRanges = {
            Today: [freshPstToday.clone(), freshPstToday.clone()],
            Yesterday: [freshPstYesterday.clone(), freshPstYesterday.clone()],
            "7D": [freshPstToday.clone().subtract(6, "days"), freshPstToday.clone()],
            "30D": [freshPstToday.clone().subtract(29, "days"), freshPstToday.clone()],
            // "3M": [moment().subtract(3, "months"), moment()],
        };
        const [start, end] = freshRanges[label];

        setDateRange({ start, end });
        setActive(label);

        // Sync the calendar picker to show the correct highlighted range
        if (pickerRef.current) {
            pickerRef.current.setStartDate(start.toDate());
            pickerRef.current.setEndDate(end.toDate());
        }
    };

    const rightRange = useMemo(() => {

        if (!dateRange?.start || !dateRange?.end) return null;

        const start = dateRange.start.clone();
        const end = dateRange.end.clone();

        const diff = end.diff(start, "days") + 1;

        const prevEnd = start.clone().subtract(1, "day");
        const prevStart = prevEnd.clone().subtract(diff - 1, "day");

        return { start: prevStart, end: prevEnd };

    }, [dateRange]);


    const [comparisionOn, setComparisionOn] = useState(true);

    // const [comparingtoggle, setComparingtoggle] = useState(false)

    const onChangeSwitch = (checked) => {
        console.log(`switch to ${checked}`);
        setComparisionOn(checked)

    };


    //---------------------------datepicker related code ends ------------------------//

    //-------------------------upper tiles related code starts--------------------------//
    const [activePublisher, setActivePublisher] = useState("");
    const [activeZones, setActiveZones] = useState("");
    const [activeDomains, setActiveDomains] = useState("");
    const [activeCtvApps, setActiveCtvApps] = useState("");
    const [activeMobileApps, setActiveMobileApps] = useState("");

    const [loaderUpperTiles, setLoaderUpperTiles] = useState(true);



    //-------------------------upper tiles related code ends--------------------------//

    //-----------------------------------performance grapfh related  code  starts-----------------------------------//

    // const formatNumber = (value) => {
    //     if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
    //     if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
    //     if (value >= 1_000) return (value / 1_000).toFixed(0) + "k";
    //     return value;
    // };

    function formatNumber(num) {
        if (num === null || num === undefined) return "";

        const absNum = Math.abs(num);

        if (absNum >= 1e15) {
            return (num / 1e15).toFixed(1).replace(/\.0$/, "") + "Q";
        } else if (absNum >= 1e12) {
            return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T";
        } else if (absNum >= 1e9) {
            return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
        } else if (absNum >= 1e6) {
            return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
        } else if (absNum >= 1e3) {
            return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
        } else {
            return num.toString();
        }
    }

    const getBadgeClass = (percent) => {
        return percent >= 0 ? "--success" : "--danger";
    };

    const [apiData, setApiData] = useState(null);
    const [selectedMetrics, setSelectedMetrics] = useState([]);

    const [revenueTotal, setRevenueTotal] = useState(null);
    const [requestTotal, setRequestTotal] = useState(null);
    const [ecpmTotal, setEcpmTotal] = useState(null);
    const [impressionTotal, setImpressionTotal] = useState(null);
    const [fillrateTotal, setFillrateTotal] = useState(null);
    const [ivtTotal, setIvtTotal] = useState(null)
    const [loaderPerformance, setLoaderPerformance] = useState(true)


    const [initialLoad, setInitialLoad] = useState(true);

    const abortControllerRef = useRef(null);
    useEffect(() => {
        fetchDashboard();
        setInitialLoad(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (!initialLoad) {
            fetchDashboard();
        }
        //api to get format type
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateRange]);

    useEffect(() => {

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            //upper tiles data hit ------------------------------------------------------

            axios
                .post(configData.SERVER_URL + `dashboard_new/dashboardTopTitle `,
                    {
                        startDate: dateRange.start.format("YYYY-MM-DD"),
                        endDate: dateRange.end.format("YYYY-MM-DD"),
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                        // signal: controller.signal
                    })
                .then((response) => {

                    if (response.data.success) {
                        setActivePublisher(response.data.active_publishers)
                        setActiveZones(response.data.active_zones)
                        setActiveDomains(response.data.active_domains)
                        setActiveCtvApps(response.data.active_ctv_apps)
                        setActiveMobileApps(response.data.active_mobile_apps)

                    }
                    else {
                        setActivePublisher("")
                        setActiveZones("")
                        setActiveDomains("")
                        setActiveCtvApps("")
                        setActiveMobileApps("")

                    }

                    setLoaderUpperTiles(false)
                })
                .catch((error) => {
                    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                        return; // ignore cancelled request
                    }
                    setActivePublisher("")
                    setActiveZones("")
                    setActiveDomains("")
                    setActiveCtvApps("")
                    setActiveMobileApps("")

                    setLoaderUpperTiles(false)
                });

        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchDashboard = async () => {

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        // 🟢 Create new controller
        const controller = new AbortController();
        abortControllerRef.current = controller;

        setLoaderTileCountryApi(true)
        // setLoaderTileTrafficApi(true)
        setLoaderTileAdvertiserApi(true)
        setLoaderTileIvtApi(true)
        setLoaderTileDomainApi(true)
        setLoaderPerformance(true)
        // setLoaderTileFormatApi(true)




        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            //8 tiles api hit--------------------------------------------------------------------
            //api to get format type data
            // axios
            //     .post(configData.SERVER_URL + `dashboard_new/dashboardTopFormat`,
            //         {
            //             startDate: dateRange.start.format("YYYY-MM-DD"),
            //             endDate: dateRange.end.format("YYYY-MM-DD"),
            //         },
            //         {
            //             headers: {
            //                 "Content-Type": "application/json",
            //                 "x-access-token": token,
            //             },
            //             signal: controller.signal
            //         })
            //     .then((response) => {
            //         if (response.data.success) {
            //             setTopFormatType(response.data.data.format?.slice(0, 8))

            //         }
            //         else {
            //             setTopFormatType([])
            //         }

            //         setLoaderTileFormatApi(false)
            //     })
            //     .catch((error) => {
            //         if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
            //             return; // ignore cancelled request
            //         }
            //         setTopFormatType([])
            //         setLoaderTileFormatApi(false)
            //     });

            //api to get publisher, zone , dsp and country
            axios
                .post(configData.SERVER_URL + `dashboard_new`,
                    {
                        startDate: dateRange.start.format("YYYY-MM-DD"),
                        endDate: dateRange.end.format("YYYY-MM-DD"),
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                        signal: controller.signal
                    })
                .then((response) => {
                    if (response.data.success) {

                        setTopCountry(response.data.data.country?.slice(0, 8));
                        if (props.role !== "admin" && props.role !== "u_admin") {
                            setTopDsp(response.data.data.dsp?.slice(0, 8));
                        }
                    }
                    else {

                        setTopCountry([])
                        if (props.role !== "admin" && props.role !== "u_admin") {
                            setTopDsp([])
                        }
                    }

                    setLoaderTileCountryApi(false)
                })
                .catch((error) => {
                    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                        return; // ignore cancelled request
                    }

                    setTopCountry([])
                    if (props.role !== "admin" && props.role !== "u_admin") {
                        setTopDsp([])
                    }

                    setLoaderTileCountryApi(false)
                });

            //api to get traffic type
            // setTimeout(() => {
            //     axios
            //         .post(configData.SERVER_URL + `dashboard_new/dashboardTopTraffic`,
            //             {
            //                 startDate: dateRange.start.format("YYYY-MM-DD"),
            //                 endDate: dateRange.end.format("YYYY-MM-DD"),
            //             },
            //             {
            //                 headers: {
            //                     "Content-Type": "application/json",
            //                     "x-access-token": token,
            //                 },
            //                 signal: controller.signal
            //             })
            //         .then((response) => {
            //             if (response.data.success) {
            //                 setTopTrafficType(response.data.data.tarffic?.slice(0, 8))

            //             }
            //             else {
            //                 setTopTrafficType([])
            //             }

            //             setLoaderTileTrafficApi(false)
            //         })
            //         .catch((error) => {
            //             if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
            //                 return; // ignore cancelled request
            //             }
            //             setTopTrafficType([])
            //             setLoaderTileTrafficApi(false)
            //         });

            // }, 1200)


            //api to get advertiser
            setTimeout(() => {
                axios
                    .post(configData.SERVER_URL + `dashboard_new/dashboardTopAdvertiser`,
                        {
                            startDate: dateRange.start.format("YYYY-MM-DD"),
                            endDate: dateRange.end.format("YYYY-MM-DD"),
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                            signal: controller.signal
                        })
                    .then((response) => {
                        if (response.data.success) {
                            setTopAdvertiser(response.data.data.traffic?.slice(0, 8))

                        }
                        else {
                            setTopAdvertiser([])
                        }

                        setLoaderTileAdvertiserApi(false)
                    })
                    .catch((error) => {
                        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                            return; // ignore cancelled request
                        }
                        setTopAdvertiser([])
                        setLoaderTileAdvertiserApi(false)
                    });
            }, 1200)


            //api to get ivt
            axios
                .post(configData.SERVER_URL + `dashboard_new/getTopIVTComparison`,
                    {
                        startDate: dateRange.start.format("YYYY-MM-DD"),
                        endDate: dateRange.end.format("YYYY-MM-DD"),
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                        signal: controller.signal
                    })
                .then((response) => {
                    if (response.data.success) {

                        if ((response.data.data?.human || []).length === 0 && (response.data.data?.doubleVerify || []).length > 0) {
                            setTopIvtType("doubleVerify")
                        }
                        else {

                            setTopIvtType("human")
                        }

                        setTopIvtDoubleVerify((response.data.data?.doubleVerify || []).slice(0, 8));
                        setTopIvtHuman((response.data.data?.human || []).slice(0, 8))

                    }
                    else {
                        setTopIvtType("human")
                        setTopIvtDoubleVerify([])
                        setTopIvtHuman([])
                    }

                    setLoaderTileIvtApi(false)
                })
                .catch((error) => {
                    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                        return; // ignore cancelled request
                    }
                    setTopIvtType("human")
                    setTopIvtDoubleVerify([])
                    setTopIvtHuman([])
                    setLoaderTileIvtApi(false)
                });

            //api to get domain
            setTimeout(() => {
                axios
                    .post(configData.SERVER_URL + `dashboard_new/dashboardTopDomainData`,
                        {
                            startDate: dateRange.start.format("YYYY-MM-DD"),
                            endDate: dateRange.end.format("YYYY-MM-DD"),
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                            signal: controller.signal
                        })
                    .then((response) => {
                        if (response.data.success) {
                            setTopDomains(response.data.data.domain?.slice(0, 8))

                        }
                        else {
                            setTopDomains([])
                        }

                        setLoaderTileDomainApi(false)
                    })
                    .catch((error) => {
                        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                            return; // ignore cancelled request
                        }
                        setTopDomains([])
                        setLoaderTileDomainApi(false)
                    });

            }, 1200)


            //performance metrics api hit--------------------------------------------------------------------
            //performace grapgh --------------------------------------------------------------------------
            setTimeout(() => {
                axios
                    .post(configData.SERVER_URL + `dashboard_new/dashboardGraph`,
                        {
                            startDate: dateRange.start.format("YYYY-MM-DD"),
                            endDate: dateRange.end.format("YYYY-MM-DD"),
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                            signal: controller.signal
                        })
                    .then((response) => {

                        if (response.data.success) {
                            setApiData(response.data)
                            setRevenueTotal(response.data.totals.revenue)
                            setRequestTotal(response.data.totals.total_requests)
                            setEcpmTotal(response.data.totals.ecpm)
                            setImpressionTotal(response.data.totals.total_impressions)
                            setFillrateTotal(response.data.totals.fill_rate)
                            // IVT SUNSET: IVT no longer returned by API
                            // setIvtTotal(response.data.totals.ivt)
                            setTopPublishers(response.data.top_publishers?.slice(0, 8));
                            setTopZones(response.data.top_zones?.slice(0, 8));
                            setTopTrafficType(response.data.top_traffic?.slice(0, 8))
                            setTopFormatType(response.data.top_format?.slice(0, 8))

                        }
                        else {
                            setApiData(null)
                            setRevenueTotal(null)
                            setRequestTotal(null)
                            setEcpmTotal(null)
                            setImpressionTotal(null)
                            setFillrateTotal(null)
                            setIvtTotal(null)
                            setTopPublishers([])
                            setTopZones([])
                            setTopTrafficType([])
                            setTopFormatType([])

                        }

                        setLoaderPerformance(false)

                    })
                    .catch((error) => {
                        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                            return; // ignore cancelled request
                        }

                        setApiData(null)
                        setRevenueTotal(null)
                        setRequestTotal(null)
                        setEcpmTotal(null)
                        setImpressionTotal(null)
                        setFillrateTotal(null)
                        setIvtTotal(null)
                        setLoaderPerformance(false)
                        setTopPublishers([])
                        setTopZones([])
                        setTopTrafficType([])
                        setTopFormatType([])

                    });


            }, 1200)

        }

        // setApiData({
        //     "meta": {
        //         "current_range": {
        //             "start": "2026-05-06",
        //             "end": "2026-05-24",
        //             "days": 19
        //         },
        //         "previous_range": {
        //             "start": "2026-04-17",
        //             "end": "2026-05-05",
        //             "days": 19
        //         }
        //     },

        //     "categories": [
        //         "06 May", "07 May", "08 May", "09 May", "10 May",
        //         "11 May", "12 May", "13 May", "14 May", "15 May",
        //         "16 May", "17 May", "18 May", "19 May", "20 May",
        //         "21 May", "22 May", "23 May", "24 May"
        //     ],

        //     "metrics": {

        //         "revenue": {
        //             "current": [42000, 39000, 50000, 26000, 8000, 32000, 28000, 46000, 5000, 40000, 30000, 7000, 6000, 32000, 40000, 48000, 30000, 33000, 56000],
        //             "previous": [26000, 24000, 28000, 18000, 20000, 15000, 21000, 30000, 20000, 24000, 26000, 18000, 15000, 20000, 24000, 42000, 27000, 31000, 35000],
        //             "percent_change": [61.5, 62.5, 78.6, 44.4, -60.0, 113.3, 33.3, 53.3, -75.0, 66.7, 15.4, -61.1, -60.0, 60.0, 66.7, 14.3, 11.1, 6.5, 60.0]
        //         },

        //         "total_requests": {
        //             "current": [120000, 130000, 90000, 110000, 150000, 125000, 98000, 102000, 140000, 118000, 132000, 100000, 145000, 110000, 137000, 150000, 105000, 142000, 160000],
        //             "previous": [100000, 110000, 80000, 95000, 120000, 115000, 90000, 95000, 125000, 100000, 120000, 92000, 130000, 100000, 125000, 130000, 95000, 120000, 140000],
        //             "percent_change": [20.0, 18.2, 12.5, 15.8, 25.0, 8.7, 8.9, 7.4, 12.0, 18.0, 10.0, 8.7, 11.5, 10.0, 9.6, 15.4, 10.5, 18.3, 14.3]
        //         },

        //         "ecpm": {
        //             "current": [8.1, 9.2, 7.5, 10.3, 6.2, 8.4, 9.0, 7.8, 10.5, 6.9, 8.2, 7.7, 9.1, 8.6, 10.2, 7.4, 8.9, 9.3, 8.0],
        //             "previous": [7.2, 8.4, 6.9, 9.1, 5.8, 7.6, 8.3, 7.2, 9.6, 6.2, 7.5, 7.1, 8.4, 8.0, 9.5, 6.9, 8.2, 8.7, 7.4],
        //             "percent_change": [12.5, 9.5, 8.7, 13.2, 6.9, 10.5, 8.4, 8.3, 9.4, 11.3, 9.3, 8.5, 8.3, 7.5, 7.4, 7.2, 8.5, 6.9, 8.1]
        //         },

        //         "total_impressions": {
        //             "current": [58000, 60000, 38000, 32000, 42000, 28000, 21000, 12000, 26000, 34000, 41000, 26000, 50000, 36000, 42000, 46000, 30000, 52000, 47000],
        //             "previous": [60000, 55000, 35000, 30000, 28000, 34000, 22000, 16000, 30000, 26000, 32000, 28000, 46000, 30000, 42000, 24000, 26000, 28000, 25000],
        //             "percent_change": [-3.3, 9.1, 8.6, 6.7, 50.0, -17.6, -4.5, -25.0, -13.3, 30.8, 28.1, -7.1, 8.7, 20.0, 0.0, 91.7, 15.4, 85.7, 88.0]
        //         },

        //         "fill_rate": {
        //             "current": [0.52, 0.55, 0.49, 0.60, 0.48, 0.51, 0.53, 0.57, 0.62, 0.59, 0.54, 0.50, 0.58, 0.56, 0.61, 0.63, 0.55, 0.60, 0.64],
        //             "previous": [0.48, 0.50, 0.45, 0.55, 0.44, 0.47, 0.49, 0.52, 0.58, 0.54, 0.50, 0.46, 0.53, 0.51, 0.56, 0.59, 0.50, 0.55, 0.60],
        //             "percent_change": [8.3, 10.0, 8.9, 9.1, 9.1, 8.5, 8.2, 9.6, 6.9, 9.3, 8.0, 8.7, 9.4, 9.8, 8.9, 6.8, 10.0, 9.1, 6.7]
        //         },

        //         "ivt": {
        //             "current": [0.07, 0.06, 0.08, 0.05, 0.09, 0.07, 0.06, 0.08, 0.05, 0.07, 0.06, 0.08, 0.05, 0.07, 0.06, 0.08, 0.05, 0.07, 0.06],
        //             "previous": [0.06, 0.07, 0.09, 0.06, 0.10, 0.08, 0.07, 0.09, 0.06, 0.08, 0.07, 0.09, 0.06, 0.08, 0.07, 0.09, 0.06, 0.08, 0.07],
        //             "percent_change": [16.7, -14.3, -11.1, -16.7, -10.0, -12.5, -14.3, -11.1, -16.7, -12.5, -14.3, -11.1, -16.7, -12.5, -14.3, -11.1, -16.7, -12.5, -14.3]
        //         }
        //     },

        //     "totals": {
        //         "revenue": {
        //             "current": 595000,
        //             "previous": 460000,
        //             "difference": 135000,
        //             "percent_change": 29.3,
        //         },
        //         "total_requests": {
        //             "current": 2500000,
        //             "previous": 2200000,
        //             "difference": 300000,
        //             "percent_change": 13.6,

        //         },
        //         "ecpm": {
        //             "current": 8.67,
        //             "previous": 7.89,
        //             "difference": 0.78,
        //             "percent_change": 9.9,

        //         },
        //         "total_impressions": {
        //             "current": 675000,
        //             "previous": 590000,
        //             "difference": 85000,
        //             "percent_change": 14.4,

        //         },
        //         "fill_rate": {
        //             "current": 0.57,
        //             "previous": 0.52,
        //             "difference": 0.05,
        //             "percent_change": 9.6,

        //         },
        //         "ivt": {
        //             "current": 0.07,
        //             "previous": 0.08,
        //             "difference": -0.01,
        //             "percent_change": -12.5,

        //         }
        //     }
        // })


    };

    const toggleMetric = (metricKey) => {
        setSelectedMetrics(prev => {

            if (prev.includes(metricKey)) {
                return prev.filter(m => m !== metricKey);
            }

            if (prev.length < 2) {
                return [...prev, metricKey];
            }

            // remove oldest (first selected)
            return [prev[1], metricKey];
        });
    };


    const chartRef = useRef(null);
    const barCrosshairOffsetRef = useRef(0); // pixels to shift crosshair between grey & purple bar

    const metricColorMap = {
        revenue: "#7C3AED",         // purple
        total_requests: "#0029CC",  // blue
        ecpm: "#125F64",            // green
        total_impressions: "#F25B0A", // orange
        fill_rate: "#0098CD",       // red
        ivt: "#A9A900"              // cyan
    };

    const chartSeries = useMemo(() => {
        if (!apiData) return [];

        const series = [];

        // Revenue → always axis 0

        if (comparisionOn) {
            series.push({
                name: "Previous revenue",
                type: "column",
                data: apiData.metrics.revenue.previous,
                color: "#EAECF0",
                yAxisIndex: 0
            });
        }

        series.push({
            name: "Current revenue",
            type: "column",
            data: apiData.metrics.revenue.current,
            color: metricColorMap.revenue,
            yAxisIndex: 0
        });


        selectedMetrics.forEach((metricKey, i) => {
            const metric = apiData.metrics[metricKey];
            const baseColor = metricColorMap[metricKey];
            // Both Current and Previous share the same axis index so they
            // are plotted on an identical scale — fixes inverted / misaligned lines.
            const axisIndex = comparisionOn ? 2 + i : 1 + i;

            series.push({
                name: `Current ${metricKey}`,
                type: "line",
                data: metric.current,
                color: baseColor,
                yAxisIndex: axisIndex
            });

            if (comparisionOn) {
                series.push({
                    name: `Previous ${metricKey}`,
                    type: "line",
                    data: metric.previous,
                    color: baseColor,
                    yAxisIndex: axisIndex  // ✅ same axis as Current — shared scale
                });
            }
        });


        return series;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiData, selectedMetrics, comparisionOn]);


    const revenueScale = useMemo(() => {

        if (!apiData) return { min: 0, max: 100 };

        const allValues = [
            ...apiData.metrics.revenue.current,
            ...apiData.metrics.revenue.previous
        ];

        const maxVal = Math.max(...allValues);

        // Add 15% headroom so bars never visually overflow the top tick label
        const paddedMax = maxVal * 1.15;

        // Compute a "nice" max that is cleanly divisible by tickAmount (5)
        // so every tick label is a round number and top label always > maxVal
        const roughStep = paddedMax / 5;
        const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
        const niceStep = Math.ceil(roughStep / magnitude) * magnitude;
        const roundedMax = niceStep * 5;

        return {
            min: 0,
            max: roundedMax
        };
    }, [apiData]);

    const chartOptions = useMemo(() => ({

        states: {
            hover: {
                filter: {
                    type: "none"   // 🔥 ye main fix hai
                }
            },
            active: {
                filter: {
                    type: "none"
                }
            }
        },

        chart: {
            id: "performance-chart",
            type: "line",
            height: 320,
            stacked: false,
            zoom: {
                enabled: false
            },
            toolbar: { show: false },
            animations: { enabled: false },
            events: {
                // Measure actual bar width after chart renders
                mounted: (chartCtx) => {
                    const el = chartCtx.el?.querySelector?.(".apexcharts-bar-series .apexcharts-bar-area");
                    if (el) {
                        const bbox = el.getBBox?.();
                        barCrosshairOffsetRef.current = bbox ? bbox.width / 2 : 0;
                    }
                },
                updated: (chartCtx) => {
                    const el = chartCtx.el?.querySelector?.(".apexcharts-bar-series .apexcharts-bar-area");
                    if (el) {
                        const bbox = el.getBBox?.();
                        barCrosshairOffsetRef.current = bbox ? bbox.width / 2 : 0;
                    }
                },
                // Shift crosshair between grey & purple bars; restore for line hover
                mouseMove: (event, chartCtx, config) => {
                    const chartEl = chartCtx.el;
                    if (!chartEl) return;
                    const crosshairLine = chartEl.querySelector(".apexcharts-xcrosshairs");
                    if (!crosshairLine) return;

                    // Attach a smooth transition once (idempotent)
                    if (!crosshairLine.dataset.transitionSet) {
                        crosshairLine.style.transition = "transform 0s ease";
                        crosshairLine.dataset.transitionSet = "1";
                    }

                    const si = config.seriesIndex;
                    const series = chartCtx.w?.config?.series || [];
                    const hoveredIsLine = si >= 0 && series[si]?.type === "line";

                    if (!hoveredIsLine && comparisionOn) {
                        // Bar hover + comparison ON: shift crosshair to gap between grey and purple bar
                        const offset = barCrosshairOffsetRef.current || 0;
                        crosshairLine.style.transform = `translateX(${offset}px)`;
                    } else {
                        // Line hover OR comparison OFF: keep crosshair at natural position
                        crosshairLine.style.transform = "translateX(0px)";
                    }
                },
                mouseLeave: (event, chartCtx) => {
                    const crosshairLine = chartCtx.el?.querySelector?.(".apexcharts-xcrosshairs");
                    if (crosshairLine) crosshairLine.style.transform = "translateX(0px)";
                }
            }
        },

        stroke: {
            curve: "smooth",
            width: chartSeries.map(s =>
                s.type === "column" ? 0 : 2
            ),
            dashArray: chartSeries.map(s =>
                s.type === "line" && s.name.includes("Previous") ? 5 : 0
            )
        },

        plotOptions: {
            bar: {
                columnWidth: "45%",
                // borderRadius: 6,
                // borderRadiusApplication: "end"
            }
        },

        markers: {
            size: chartSeries.map(s =>
                s.type === "line" ? 3 : 0
            )
        },
        // markers: {
        //     size: chartSeries.map(s =>
        //         s.type === "line" && !s.name.includes("Previous") ? 3 : 0
        //     )
        // },

        fill: {
            type: chartSeries.map(s => s.type === "column" ? "gradient" : "solid"),
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.4,
                inverseColors: false,
                // gradientToColors: ["#EAECF0"],
                opacityFrom: 1,
                opacityTo: 0.9,
                stops: [0, 90, 100]
            }
        },
        dataLabels: {
            enabled: false
        },

        xaxis: {
            tooltip: {
                enabled: false   // 🔥 ye line add karo
            },
            categories: apiData?.categories || []
        },


        // yaxis: [
        //     {
        //         seriesName: "Current revenue",  // 👈 anchor to current
        //         min: revenueScale.min,
        //         max: revenueScale.max,
        //         tickAmount: 5,
        //         forceNiceScale: false,
        //         labels: {
        //             show: true,
        //             formatter: (val) => "$" + formatNumber(val)
        //         }
        //     },
        //     {
        //         seriesName: "Previous revenue",  // 👈 force same scale for previous
        //         min: revenueScale.min,
        //         max: revenueScale.max,
        //         show: false,                     // hide duplicate axis
        //     },
        //     {
        //         show: false,
        //         opposite: true                   // for line metrics
        //     }
        // ],

        yaxis: (() => {
            // yaxis must have exactly one entry per series in chartSeries.
            // Series order when comparisionOn=true:
            //   [Previous revenue(col), Current revenue(col), Current m0(line), Previous m0(line), ...]
            // Series order when comparisionOn=false:
            //   [Current revenue(col), Current m0(line), ...]
            const axes = [];

            if (comparisionOn) {
                // Previous revenue axis — hidden, same scale as current so bars render at same height
                axes.push({
                    seriesName: "Previous revenue",
                    min: revenueScale.min,
                    max: revenueScale.max,
                    tickAmount: 5,
                    forceNiceScale: false,
                    decimalsInFloat: 0,
                    show: false
                });
            }

            // Current revenue axis — visible on left
            axes.push({
                seriesName: "Current revenue",
                min: revenueScale.min,
                max: revenueScale.max,
                tickAmount: 5,
                forceNiceScale: false,
                decimalsInFloat: 0,
                labels: {
                    show: true,
                    formatter: (val) => "$" + formatNumber(Math.round(val))
                }
            });

            // One axis per series for line metrics.
            // Current and Previous of the SAME metric share the same seriesName anchor
            // → ApexCharts locks them to an identical scale (fixes inverted / misaligned lines).
            // Each DIFFERENT metric gets its own axis
            // → they auto-scale independently of each other (fixes relative-scaling between metrics).
            selectedMetrics.forEach((metricKey) => {
                // Current metric axis — anchored by seriesName, hidden
                axes.push({
                    seriesName: `Current ${metricKey}`,
                    show: false,
                    opposite: true,
                    min: 0
                });

                if (comparisionOn) {
                    // Previous metric axis — also anchored to the SAME seriesName as Current
                    // so ApexCharts forces both onto the identical min/max scale
                    axes.push({
                        seriesName: `Current ${metricKey}`,  // ← same anchor = same scale
                        show: false,
                        opposite: true,
                        min: 0
                    });
                }
            });

            // selectedMetrics.forEach((metricKey, i) => {
            //     const isPercent = metricKey === "fill_rate" || metricKey === "ivt";
            //     const isDollar = metricKey === "ecpm";
            //     const color = metricColorMap[metricKey];

            //     const formatter = (val) => {
            //         if (isPercent) return val?.toFixed(2) + "%";
            //         if (isDollar) return "$" + val?.toFixed(2);
            //         return formatNumber(Math.round(val ?? 0));
            //     };

            //     // Current metric axis — visible on the right
            //     axes.push({
            //         seriesName: `Current ${metricKey}`,
            //         opposite: true,
            //         tickAmount: 5,
            //         labels: {
            //             show: true,
            //             formatter,
            //             style: { colors: color }   // color-coded to match the line
            //         }
            //     });

            // If comparison is ON, the "Previous" series shares the same scale — hide it
            //     if (comparisionOn) {
            //         axes.push({ show: false, opposite: true });
            //     }
            // });

            return axes;
        })(),

        legend: { show: false },
        grid: {
            strokeDashArray: 4
        },
        tooltip: {
            shared: true,
            intersect: false,

            custom: function ({ dataPointIndex, w }) {

                const daysDiff = apiData.meta.current_range.days;

                // 🟢 CURRENT DATE (convert "06 May" → full date with year)
                const currentLabel = apiData.categories[dataPointIndex];
                const currentYear = apiData.meta.current_range.end.split("-")[0];

                const currentDateObj = new Date(`${currentLabel} ${currentYear}`);
                const previousDateObj = new Date(currentDateObj);
                previousDateObj.setDate(previousDateObj.getDate() - daysDiff);

                const formatDate = (date) =>
                    date.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    });

                const currentDate = formatDate(currentDateObj);
                const previousDate = formatDate(previousDateObj);

                let topRows = "";
                let bottomRows = "";

                // ✅ Revenue always first
                const metricKeys = [
                    "revenue",
                    ...selectedMetrics.filter(k => k !== "revenue")
                ];

                metricKeys.forEach((key, index) => {

                    const metric = apiData.metrics[key];
                    if (!metric) return;

                    const currentValue = metric.current[dataPointIndex];
                    const previousValue = metric.previous[dataPointIndex];
                    const percent = metric.percent_change[dataPointIndex];

                    const isPositive = percent >= 0;
                    const changeClass = isPositive ? "--high" : "--low";
                    const arrowIcon = isPositive ? arrowUpIcon : arrowDownIcon;

                    // const color = w.config.series[index * 2]?.color;
                    const color = metricColorMap[key] ?? w.config.series[index * 2]?.color;

                    let metricLabel = key
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, c => c.toUpperCase());

                    if (metricLabel === "Ecpm") {
                        metricLabel = "eCPM";
                    }

                    // 🔹 Formatting rules
                    let formattedCurrent;
                    let formattedPrevious;

                    if (key === "revenue") {
                        formattedCurrent = "$" + currentValue.toLocaleString();
                        formattedPrevious = "$" + previousValue.toLocaleString();
                    } else if (key === "ecpm") {
                        formattedCurrent = "$" + currentValue.toFixed(2);
                        formattedPrevious = "$" + previousValue.toFixed(2);
                    } else if (key === "fill_rate" || key === "ivt") {
                        // formattedCurrent = (currentValue * 100).toFixed(2) + "%";
                        // formattedPrevious = (previousValue * 100).toFixed(2) + "%";
                        formattedCurrent = currentValue;
                        formattedPrevious = previousValue;
                    } else {
                        formattedCurrent = currentValue.toLocaleString();
                        formattedPrevious = previousValue.toLocaleString();
                    }

                    // 🔹 TOP SECTION
                    topRows += `
                    <div class="--row">
                        <div class="main_value_points">
                            <div class="dot" style="background:${color}"></div>
                                <div>
                                    <span class="heading">${metricLabel}</span>
                                    ${comparisionOn ? `   <span class="${changeClass}">
                                    (${Math.abs(percent)}%)
                                    <img src=${arrowIcon} alt="trend" />
                                    </span>` : ""}
                            </div>
                        </div>
                         <div class="">
                            <div class="data">${formattedCurrent}</div>
                            ${comparisionOn ? `<div class="data">${formattedPrevious}</div>` : ""}
                        </div>
                    </div>
                    `;

                    // 🔹 BOTTOM SECTION
                    bottomRows += `
                   
                    `;
                });

                return `
                <div class="apex-tooltip-card">
                    <div class="top">
                        <div class="sideheader">
                            <b class="data">${currentDate}</b>
                            ${comparisionOn ? `<b class="data">${previousDate}</b>` : ""}
                        </div>
                        <div class="sidetable">
                            ${topRows}
                            ${bottomRows}
                        </div>
                    </div>
                </div>
                `;
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [chartSeries, apiData, comparisionOn, selectedMetrics, revenueScale]);


    //  return `
    //                 <div class="apex-tooltip-card style="width:auto">
    //                     <div class="top">
    //                     <div class="sideheader"></div>
    //                     <div class="sidetable">
    //                         ${topRows}
    //                     </div>
    //                     </div>

    //                     <div class="bottom">
    //                     <div class="sideheader">
    //                         <b class="data">${currentDate}</b>
    //                         ${comparisionOn ? `<b class="data">${previousDate}</b>` : ""}
    //                     </div>
    //                     <div class="sidetable">
    //                         ${bottomRows}
    //                     </div>
    //                     </div>
    //                 </div>
    //                 `;



    //-----------------------------------performance grapfh related  code  ends-----------------------------------//

    //-------------------------------8 tiles related code starts --------------------------------------------------//
    // const initialData = [
    //     { name: "Afghanistan", value: 44500, percent: 12.5 },
    //     { name: "Canada", value: 28300, percent: 7.6 },
    //     { name: "USA", value: 44500, percent: -10.3 },
    //     { name: "Germany", value: 35700, percent: 14.7 },
    //     { name: "Japan", value: 30100, percent: -12.8 },
    //     { name: "Australia", value: 22400, percent: -9.1 },
    //     { name: "India", value: 50200, percent: 13.4 },
    //     { name: "Brazil", value: 19800, percent: 9.8 }
    // ];

    // 🔥 default ascending
    // const [ascending, setAscending] = useState(true);

    // 🔥 sort data
    // const sortedData = useMemo(() => {
    //     return [...initialData].sort((a, b) =>
    //         ascending ? a.value - b.value : b.value - a.value
    //     );
    // }, [ascending]);

    // const maxValue = Math.max(...initialData.map(d => d.value));



    const [topPublishers, setTopPublishers] = useState([]);
    const [topZones, setTopZones] = useState([]);
    const [topCountry, setTopCountry] = useState([]);
    const [topDsp, setTopDsp] = useState([]);
    const [loaderTileCountryApi, setLoaderTileCountryApi] = useState(true);


    const [topTrafficType, setTopTrafficType] = useState([]);
    // const [loaderTileTrafficApi, setLoaderTileTrafficApi] = useState(true);

    const [topAdvertiser, setTopAdvertiser] = useState([]);
    const [loaderTileAdvertiserApi, setLoaderTileAdvertiserApi] = useState(true);

    const [topIvtType, setTopIvtType] = useState("human");
    const [topIvtDoubleVerify, setTopIvtDoubleVerify] = useState([]);
    const [topIvtHuman, setTopIvtHuman] = useState([]);
    const [loaderTileIvtApi, setLoaderTileIvtApi] = useState(true);

    const [topDomains, setTopDomains] = useState([]);
    const [loaderTileDomainApi, setLoaderTileDomainApi] = useState(true);

    const [topFormatType, setTopFormatType] = useState([]);
    // const [loaderTileFormatApi, setLoaderTileFormatApi] = useState(true);

    const TruncatedWithTooltip = ({ text, limit = 30 }) => {
        const isDoubleClicked = useRef(false);

        const handleDoubleClick = () => {
            if (text) {
                navigator.clipboard.writeText(text);
                isDoubleClicked.current = true;
            }
        };

        const handleCopy = (e) => {
            if (isDoubleClicked.current && text) {
                e.preventDefault();
                e.clipboardData.setData("text/plain", text);
                isDoubleClicked.current = false; // Reset after use
            }
            // else: default copy behavior (only visible text)
        };

        return text?.length > limit ? (
            <Tooltip title={text}>
                <span onDoubleClick={handleDoubleClick} onCopy={handleCopy}>
                    {text.slice(0, limit) + "..."}
                </span>
            </Tooltip>
        ) : (
            <span onDoubleClick={handleDoubleClick} onCopy={handleCopy}>
                {text}
            </span>
        );
    };


    function formatNumberData(num) {
        if (num === null || num === undefined) return "";

        const absNum = Math.abs(num);

        if (absNum >= 1e15) {
            return (num / 1e15).toFixed(1).replace(/\.0$/, "") + "Q";
        } else if (absNum >= 1e12) {
            return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T";
        } else if (absNum >= 1e9) {
            return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
        } else if (absNum >= 1e6) {
            return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
        } else if (absNum >= 1e3) {
            return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
        } else {
            return num.toString();
        }
    }



    const orderedTiles = useMemo(() => {

        if (props.role === "mobops" || props.role === "sa" || props.role === "am") {
            return [
                "publisher",
                "zones",
                "traffic_type",
                "dsp",
                "advertiser",
                "ivt",
                "country",
                "domains"
            ];
        }

        if ((props.role === "admin" || props.role === "u_admin")) {
            return [
                "zones",
                "format_type",
                "country",
                "traffic_type",
                "advertiser",
                "domains",
                // "dsp",
                "ivt"
            ];
        }

        return [];
    }, [props.role]);


    const tileMap = {
        publisher: () => (
            <Col span={6}>

                {loaderPerformance ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>
                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">

                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Publisher
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topPublishers.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topPublishers.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name" >

                                                        <TruncatedWithTooltip
                                                            text={`${item.publisher_id}-${item.publisher}`}
                                                        />


                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topPublishers.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }


            </Col>
        ),

        zones: () => (
            <Col md={6}>
                {loaderPerformance ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Zones
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topZones.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topZones.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.zone_id}-${item.zone}`}
                                                        />

                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topZones.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        traffic_type: () => (
            <Col md={6}>
                {loaderPerformance ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Traffic Type
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topTrafficType.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topTrafficType?.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.traffic_type}`}
                                                        />
                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topTrafficType?.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        dsp: () => (
            <Col md={6}>
                {loaderTileCountryApi ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top DSP
                                                </h2>
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            >
                                                Impressions
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topDsp.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topDsp.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.remotefeed_provider}`}
                                                        />

                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topDsp.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        advertiser: () => (
            <Col md={6}>
                {loaderTileAdvertiserApi ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Advertiser
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>

                                {topAdvertiser.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topAdvertiser.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.dsp_adomain}`}
                                                        />
                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topAdvertiser.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        ivt: () => (
            <Col md={6}>
                {loaderTileIvtApi ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <div className="heading_with_select_tag">
                                                    <h2 className="heading">
                                                        Top IVT%
                                                    </h2>
                                                    <div className="form_content_block--group  mb-0 hide_caret_after_select_value">
                                                        <Select
                                                            className='form_select basic no_search'
                                                            // placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            value={topIvtType}
                                                            onChange={(event) => {
                                                                setTopIvtType(event)
                                                            }}
                                                            popupMatchSelectWidth={false}
                                                            dropdownStyle={{ width: 115 }}

                                                            options={[
                                                                { value: 'doubleVerify', label: 'Double Verify' },
                                                                { value: 'human', label: 'Human' }
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </div>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topIvtType === "doubleVerify" ?
                                    <>
                                        {topIvtDoubleVerify.length === 0 ?
                                            <div className="empty_data_icon">
                                                {(() => {
                                                    const today = moment().tz("America/Los_Angeles").startOf("day");
                                                    const yesterday = moment().tz("America/Los_Angeles").subtract(1, "day").startOf("day");
                                                    const selStart = dateRange.start.clone().startOf("day");
                                                    const selEnd = dateRange.end.clone().startOf("day");
                                                    const isTodayOrYesterday =
                                                        (selStart.isSame(today) && selEnd.isSame(today)) ||
                                                        (selStart.isSame(yesterday) && selEnd.isSame(yesterday));
                                                    return isTodayOrYesterday
                                                        ? <img src={nodataImgIVT} alt="Data processing" />
                                                        : <img src={nodataImg} alt="No data" />;
                                                })()}

                                            </div>
                                            :
                                            <>
                                                {topIvtDoubleVerify.map((item, i) => (
                                                    <div className="country_row" key={i}>
                                                        <div className="bar_group">
                                                            <span className="country_name">
                                                                <TruncatedWithTooltip
                                                                    text={`${item.zone}`}
                                                                />
                                                            </span>
                                                            <div
                                                                className="bar_fill"
                                                                style={{ width: `${(item.pub_gross_impressions / (Math.max(...topIvtDoubleVerify.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                            >

                                                            </div>
                                                            <div className="bar_wrap">

                                                            </div>

                                                            <div className="country_value">
                                                                {formatNumberData(item.pub_gross_impressions)} ({item.ivt_pct}%)
                                                            </div>

                                                        </div>
                                                        {comparisionOn &&
                                                            <div
                                                                className={`country_percent w_btn ${item.ivt_pct_change < 0 ? "--down_green" : "--up"
                                                                    }`}
                                                            >
                                                                {item.ivt_pct_change !== null ? <>{item.ivt_pct_change}<span className="percent">%</span></> : <>-</>}
                                                            </div>
                                                        }

                                                    </div>
                                                ))}
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        {topIvtHuman.length === 0 ?
                                            <div className="empty_data_icon">
                                                {(() => {
                                                    const today = moment().tz("America/Los_Angeles").startOf("day");
                                                    const yesterday = moment().tz("America/Los_Angeles").subtract(1, "day").startOf("day");
                                                    const selStart = dateRange.start.clone().startOf("day");
                                                    const selEnd = dateRange.end.clone().startOf("day");
                                                    const isTodayOrYesterday =
                                                        (selStart.isSame(today) && selEnd.isSame(today)) ||
                                                        (selStart.isSame(yesterday) && selEnd.isSame(yesterday));
                                                    return isTodayOrYesterday
                                                        ? <img src={nodataImgIVT} alt="Data processing" />
                                                        : <img src={nodataImg} alt="No data" />;
                                                })()}

                                            </div>
                                            :
                                            <>
                                                {topIvtHuman.map((item, i) => (
                                                    <div className="country_row" key={i}>
                                                        <div className="bar_group">
                                                            <span className="country_name">
                                                                <TruncatedWithTooltip
                                                                    text={`${item.zone}`}
                                                                />
                                                            </span>
                                                            <div
                                                                className="bar_fill"
                                                                style={{ width: `${(item.pub_gross_impressions / (Math.max(...topIvtHuman.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                            >

                                                            </div>
                                                            <div className="bar_wrap">

                                                            </div>

                                                            <div className="country_value">
                                                                {formatNumberData(item.pub_gross_impressions)} ({item.ivt_pct}%)
                                                            </div>

                                                        </div>
                                                        {comparisionOn &&
                                                            <div
                                                                className={`country_percent w_btn ${item.ivt_pct_change < 0 ? "--down_green" : "--up"
                                                                    }`}
                                                            >
                                                                {item.ivt_pct_change !== null ? <>{item.ivt_pct_change}<span className="percent">%</span></> : <>-</>}
                                                            </div>
                                                        }

                                                    </div>
                                                ))}
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        country: () => (
            <Col md={6}>
                {loaderTileCountryApi ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Country
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topCountry.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topCountry.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.country}`}
                                                        />
                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topCountry.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        domains: () => (
            <Col md={6}>
                {loaderTileDomainApi ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Properties
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>
                                {topDomains.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>
                                        {topDomains.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.site_domain
                                                                ? item.site_domain
                                                                : item.app_bundle
                                                                    ? item.app_bundle
                                                                    : "-"
                                                                }`}
                                                        />
                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topDomains.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        ),

        format_type: () => (
            <Col md={6}>
                {loaderPerformance ?
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <ContentLoader
                                    speed={2}
                                    width='100%'
                                    height={146}
                                    viewBox="0 0 420 146"
                                    backgroundColor="#F1F5F9"
                                    foregroundColor="#e2e8f0"
                                >
                                    <rect x="4" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="298" y="0" rx="6" ry="6" width="76" height="12" />
                                    <rect x="395" y="0" rx="6" ry="6" width="21" height="12" />

                                    <rect x="399" y="46.5" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="86" rx="6" ry="6" width="21" height="12" />
                                    <rect x="399" y="125.5" rx="6" ry="6" width="21" height="12" />

                                    <rect x="0" y="113.5" rx="8" ry="8" width="281" height="32" />
                                    <rect x="0" y="76.5" rx="8" ry="8" width="332" height="32" />
                                    <rect x="0" y="39.5" rx="8" ry="8" width="373" height="32" />
                                </ContentLoader>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='card_content_block --chart-blocks'>

                        <div className="country_chart">
                            <div className="country_table">
                                <div className="country_row">
                                    <div className="bar_group pe-0">
                                        <div className="bar_wrap_th">
                                            <div className="title d-flex justify-content-between align-items-center">
                                                <h2 className="heading">
                                                    Top Format Type
                                                </h2>
                                                {/* <button className="text_link_primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M13.6758 9.375V7.5752H11.876C11.4894 7.5752 11.1758 7.2616 11.1758 6.875C11.1758 6.4884 11.4894 6.1748 11.876 6.1748H14.376C14.7626 6.1748 15.0762 6.4884 15.0762 6.875V9.375C15.0762 9.7616 14.7626 10.0752 14.376 10.0752C13.9894 10.0752 13.6758 9.7616 13.6758 9.375Z" fill="#2B3DFF" />
                                                                    <path d="M4.92578 10.625C4.92578 10.2384 5.23938 9.9248 5.62598 9.9248C6.01258 9.9248 6.32617 10.2384 6.32617 10.625V12.4248H8.12598C8.51258 12.4248 8.82617 12.7384 8.82617 13.125C8.82617 13.5116 8.51258 13.8252 8.12598 13.8252H5.62598C5.23938 13.8252 4.92578 13.5116 4.92578 13.125V10.625Z" fill="#2B3DFF" />
                                                                    <path d="M3.20117 15.5498H16.8008V4.4502H3.20117V15.5498ZM18.2012 15.625C18.2012 16.3568 17.6078 16.9502 16.876 16.9502H3.12598C2.3942 16.9502 1.80078 16.3568 1.80078 15.625V4.375C1.80078 3.64322 2.3942 3.0498 3.12598 3.0498H16.876C17.6078 3.0498 18.2012 3.64322 18.2012 4.375V15.625Z" fill="#2B3DFF" />
                                                                </svg> Expand view</button> */}
                                            </div>
                                        </div>
                                        <div className="country_value_th">
                                            <button
                                                className="sort_btn"
                                            // onClick={() => setAscending(prev => !prev)}
                                            >
                                                Impressions
                                                {/* <img src={sortArrowIcon} className={ascending ? "sort_arrow --up" : "sort_arrow --down"} alt="Xapads" /> */}
                                            </button>
                                        </div>
                                    </div>
                                    {comparisionOn &&
                                        <div className="sort_btn w_btn">
                                            Δ %
                                        </div>
                                    }
                                </div>

                                {topFormatType.length === 0 ?
                                    <div className="empty_data_icon">
                                        <img src={nodataImg} alt="Error" />
                                    </div>
                                    :
                                    <>

                                        {topFormatType?.map((item, i) => (
                                            <div className="country_row" key={i}>
                                                <div className="bar_group">
                                                    <span className="country_name">
                                                        <TruncatedWithTooltip
                                                            text={`${item.format_type}`}
                                                        />
                                                    </span>
                                                    <div
                                                        className="bar_fill"
                                                        style={{ width: `${(item.pub_gross_impressions / (Math.max(...topFormatType.map(d => d.pub_gross_impressions)))) * 100}%` }}
                                                    >

                                                    </div>
                                                    <div className="bar_wrap">

                                                    </div>

                                                    <div className="country_value">
                                                        {formatNumberData(item.pub_gross_impressions)}
                                                    </div>

                                                </div>
                                                {comparisionOn &&
                                                    <div
                                                        className={`country_percent w_btn ${item.percentChange < 0 ? "--down" : "--up"
                                                            }`}
                                                    >
                                                        {item.percentChange !== null ? <>{item.percentChange}<span className="percent">%</span></> : <>-</>}
                                                    </div>
                                                }

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Col>
        )
    };


    //-------------------------------8 tiles related code ends --------------------------------------------------//




    return (
        <>

            <div className="container_box--wrapper pt_header --wrapper-v2">



                <div className="title_intro d-flex align-items-center justify-content-between">
                    <h1 className="heading">
                        Dashboard
                    </h1>
                    <p className="notice_text">Data shown in PST timezone</p>
                </div>

                <div className={!comparisionOn ? "card_content_gap full_width_bars_cls" : "card_content_gap"}>
                    <div className="card_content_block ff_content_block">
                        <div className="form_group form_select_datepicker ff_content_block_inner" style={{ cursor: 'default' }}>
                            <DateRangePicker
                                ref={pickerRef}
                                startDate={dateRange.start}
                                endDate={dateRange.end}
                                onShow={(event, picker) => {
                                    picker.container.addClass("hidenextprevnumberscls");
                                }}
                                initialSettings={{
                                    autoApply: true,
                                    locale: { format: "DD/MM/YYYY" },
                                    minDate: moment("2026-02-01").toDate(),
                                    // maxDate is PST today — so future local dates (e.g. India's "tomorrow") are disabled
                                    maxDate: pstToday.clone().toDate(),
                                    maxSpan: { days: 30 },
                                    startDate: dateRange.start.toDate(),
                                    endDate: dateRange.end.toDate(),
                                }}
                                onCallback={(start, end) => {
                                    const selectedStart = moment(start);
                                    const selectedEnd = moment(end);

                                    // Check if the selected range matches any preset
                                    const matchedPreset = Object.entries(ranges).find(([, [presetStart, presetEnd]]) =>
                                        selectedStart.isSame(presetStart, "day") &&
                                        selectedEnd.isSame(presetEnd, "day")
                                    );

                                    setDateRange({ start: selectedStart, end: selectedEnd });
                                    setActive(matchedPreset ? matchedPreset[0] : "Custom");
                                }}
                            >
                                <div className="picker-input form_select --daterangepicker --daterangepickerv2">
                                    {dateRange.start.format("DD MMM YYYY")} -{" "}
                                    {dateRange.end.format("DD MMM YYYY")}
                                </div>
                            </DateRangePicker>
                            <div className="custom_range_btns">
                                {Object.keys(ranges).map((label) => (
                                    <button
                                        key={label}
                                        className={`range_btn ${active === label ? "active" : ""}`}
                                        onClick={() => handlePresetClick(label)}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                            <div className="form_content_block--group form_content_toggle">
                                <Switch value={comparisionOn} onChange={onChangeSwitch} />
                                <label className='form_label'>Comparing</label>
                            </div>

                            <Input
                                style={{ width: "19rem", fontSize: '1.3rem' }}
                                value={
                                    rightRange
                                        ? `${rightRange.start.format("DD MMM YYYY")} - ${rightRange.end.format("DD MMM YYYY")}`
                                        : ""
                                }
                                disabled
                            />

                            {/* <DateRangePicker

                                ref={pickerRef}
                                startDate={dateRange.start}
                                endDate={dateRange.end}
                                initialSettings={{
                                    autoApply: true,
                                    locale: { format: "DD/MM/YYYY" },
                                    maxDate: new Date(),
                                }}
                                onCallback={(start, end) => {
                                    setDateRange({
                                        start: moment(start),
                                        end: moment(end),
                                    });
                                    setActive("Custom");
                                }}
                            >
                                <div className="picker-input form_select --daterangepicker --daterangepickerv2 --compare">
                                    {dateRange.start.format("DD MMM YYYY")} -{" "}
                                    {dateRange.end.format("DD MMM YYYY")}
                                </div>
                            </DateRangePicker> */}
                        </div>

                    </div>

                    {loaderUpperTiles ?
                        <div className="card_content_gap">
                            <div className="card_content_block metric_stats_content_block">
                                {(props.role !== "admin" && props.role !== "u_admin") &&
                                    <div className="metric_stats_content">
                                        <ContentLoader
                                            speed={2}
                                            width='100%'
                                            height={67}
                                            viewBox="0 0 168 67"
                                            backgroundColor="#F1F5F9"
                                            foregroundColor="#e2e8f0"
                                        >
                                            <rect x="0" y="0" rx="16" ry="16" width="72" height="67" />
                                            <rect x="92" y="3.5" rx="6" ry="6" width="76" height="12" />
                                            <rect x="92" y="43.5" rx="10" ry="10" width="76" height="20" />
                                        </ContentLoader>
                                    </div>
                                }
                                <div className="metric_stats_content">
                                    <ContentLoader
                                        speed={2}
                                        width='100%'
                                        height={67}
                                        viewBox="0 0 168 67"
                                        backgroundColor="#F1F5F9"
                                        foregroundColor="#e2e8f0"
                                    >
                                        <rect x="0" y="0" rx="16" ry="16" width="72" height="67" />
                                        <rect x="92" y="3.5" rx="6" ry="6" width="76" height="12" />
                                        <rect x="92" y="43.5" rx="10" ry="10" width="76" height="20" />
                                    </ContentLoader>
                                </div>

                                <div className="metric_stats_content">
                                    <ContentLoader
                                        speed={2}
                                        width='100%'
                                        height={67}
                                        viewBox="0 0 168 67"
                                        backgroundColor="#F1F5F9"
                                        foregroundColor="#e2e8f0"
                                    >
                                        <rect x="0" y="0" rx="16" ry="16" width="72" height="67" />
                                        <rect x="92" y="3.5" rx="6" ry="6" width="76" height="12" />
                                        <rect x="92" y="43.5" rx="10" ry="10" width="76" height="20" />
                                    </ContentLoader>
                                </div>

                                <div className="metric_stats_content">
                                    <ContentLoader
                                        speed={2}
                                        width='100%'
                                        height={67}
                                        viewBox="0 0 168 67"
                                        backgroundColor="#F1F5F9"
                                        foregroundColor="#e2e8f0"
                                    >
                                        <rect x="0" y="0" rx="16" ry="16" width="72" height="67" />
                                        <rect x="92" y="3.5" rx="6" ry="6" width="76" height="12" />
                                        <rect x="92" y="43.5" rx="10" ry="10" width="76" height="20" />
                                    </ContentLoader>
                                </div>

                                <div className="metric_stats_content">
                                    <ContentLoader
                                        speed={2}
                                        width='100%'
                                        height={67}
                                        viewBox="0 0 168 67"
                                        backgroundColor="#F1F5F9"
                                        foregroundColor="#e2e8f0"
                                    >
                                        <rect x="0" y="0" rx="16" ry="16" width="72" height="67" />
                                        <rect x="92" y="3.5" rx="6" ry="6" width="76" height="12" />
                                        <rect x="92" y="43.5" rx="10" ry="10" width="76" height="20" />
                                    </ContentLoader>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card_content_block metric_stats_content_block">
                            {(props.role !== "admin" && props.role !== "u_admin") &&
                                <div className="metric_stats_content">
                                    <div className="--icon --1">
                                        <img src={publisherIcon} alt='Helix' />
                                    </div>
                                    <div className="--details">
                                        <span className="sub_head">Active Publishers</span>
                                        {activePublisher === "" ?
                                            <h3 className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                                                <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                            </svg></h3>
                                            :
                                            <h3 className="heading">{activePublisher}</h3>
                                        }

                                    </div>
                                </div>
                            }
                            <div className="metric_stats_content">
                                <div className="--icon --2">
                                    <img src={zoneIcon} alt='Helix' />
                                </div>
                                <div className="--details">
                                    <span className="sub_head">Active Zones</span>
                                    {activeZones === "" ?
                                        <h3 className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                                            <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                            <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                        </svg></h3>
                                        :
                                        <h3 className="heading">{activeZones}</h3>
                                    }
                                </div>
                            </div>

                            <div className="metric_stats_content">
                                <div className="--icon --3">
                                    <img src={linkIcon} alt='Helix' />
                                </div>
                                <div className="--details">
                                    <span className="sub_head">Active Domains</span>
                                    {activeDomains === "" ?
                                        <h3 className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                                            <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                            <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                        </svg></h3>
                                        :
                                        <h3 className="heading">{activeDomains}</h3>
                                    }
                                </div>
                            </div>

                            <div className="metric_stats_content">
                                <div className="--icon --4">
                                    <img src={ctvIcon} alt='Helix' />
                                </div>
                                <div className="--details">
                                    <span className="sub_head">Active CTV Apps</span>
                                    {activeCtvApps === "" ?
                                        <h3 className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                                            <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                            <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                        </svg></h3>
                                        :
                                        <h3 className="heading">{activeCtvApps}</h3>
                                    }
                                </div>
                            </div>

                            <div className="metric_stats_content">
                                <div className="--icon --5">
                                    <img src={gridIcon} alt='Helix' />
                                </div>
                                <div className="--details">
                                    <span className="sub_head">Active Mobile Apps</span>
                                    {activeMobileApps === "" ?
                                        <h3 className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                                            <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                            <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                        </svg></h3>
                                        :
                                        <h3 className="heading">{activeMobileApps}</h3>
                                    }
                                </div>
                            </div>
                        </div>
                    }




                    <div className={comparisionOn === false ? 'card_content_block metrics_content_block bar_single_value' : 'card_content_block metrics_content_block'}>
                        <div className="title">
                            <h2 className="heading">
                                Performance
                            </h2>
                        </div>
                        {loaderPerformance ?
                            <>
                                <div className="metrics_card_block">
                                    <label className={`metrics_card --1 `}>
                                        <div className="--content">
                                            <ContentLoader
                                                speed={2}
                                                width='100%'
                                                height={93}
                                                viewBox="0 0 230 98"
                                                backgroundColor="#F1F5F9"
                                                foregroundColor="#e2e8f0"
                                            >
                                                <rect x="0" y="4.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="61.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="81.5" rx="6" ry="6" width="76" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </label>
                                    <label className={`metrics_card --2 `}>
                                        <div className="--content">
                                            <ContentLoader
                                                speed={2}
                                                width='100%'
                                                height={93}
                                                viewBox="0 0 230 98"
                                                backgroundColor="#F1F5F9"
                                                foregroundColor="#e2e8f0"
                                            >
                                                <rect x="0" y="4.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="61.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="81.5" rx="6" ry="6" width="76" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </label>
                                    <label className={`metrics_card --3 `}>
                                        <div className="--content">
                                            <ContentLoader
                                                speed={2}
                                                width='100%'
                                                height={93}
                                                viewBox="0 0 230 98"
                                                backgroundColor="#F1F5F9"
                                                foregroundColor="#e2e8f0"
                                            >
                                                <rect x="0" y="4.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="61.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="81.5" rx="6" ry="6" width="76" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </label>
                                    <label className={`metrics_card --4 `}>
                                        <div className="--content">
                                            <ContentLoader
                                                speed={2}
                                                width='100%'
                                                height={93}
                                                viewBox="0 0 230 98"
                                                backgroundColor="#F1F5F9"
                                                foregroundColor="#e2e8f0"
                                            >
                                                <rect x="0" y="4.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="61.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="81.5" rx="6" ry="6" width="76" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </label>
                                    <label className={`metrics_card --5 `}>
                                        <div className="--content">
                                            <ContentLoader
                                                speed={2}
                                                width='100%'
                                                height={93}
                                                viewBox="0 0 230 98"
                                                backgroundColor="#F1F5F9"
                                                foregroundColor="#e2e8f0"
                                            >
                                                <rect x="0" y="4.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="61.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="81.5" rx="6" ry="6" width="76" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </label>
                                    {/* <label className={`metrics_card --6 `}>
                                        <div className="--content">
                                            <ContentLoader
                                                speed={2}
                                                width='100%'
                                                height={93}
                                                viewBox="0 0 230 98"
                                                backgroundColor="#F1F5F9"
                                                foregroundColor="#e2e8f0"
                                            >
                                                <rect x="0" y="4.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="61.5" rx="6" ry="6" width="76" height="12" />
                                                <rect x="0" y="81.5" rx="6" ry="6" width="76" height="12" />
                                            </ContentLoader>
                                        </div>
                                    </label> */}
                                </div>

                                <div className="chart_block_content">
                                    <ContentLoader
                                        speed={2}
                                        width="100%"
                                        preserveAspectRatio="none"
                                        height={355}
                                        viewBox="0 0 1793 329"
                                        backgroundColor="#F1F5F9"
                                        foregroundColor="#e2e8f0"
                                    >

                                        <rect x="1328" y="4" rx="6" ry="6" width="105" height="12" />
                                        <rect x="1449" y="4" rx="6" ry="6" width="105" height="12" />
                                        <rect x="1586" y="0" rx="10" ry="10" width="207" height="20" />

                                        <path d="M 1334 16 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 z M 1455 16 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 z M 1596 20 h 187 c 5.5 0 10 -4.5 10 -10 s -4.5 -10 -10 -10 h -187 c -5.5 0 -10 4.5 -10 10 s 4.5 10 10 10 z M 1791.4 55.2 l -51.8 36.9 l 13.6 -13.4 c 0.4 -0.4 0.4 -1 0 -1.4 c -0.4 -0.4 -1 -0.4 -1.4 0 l -22.6 22.2 l -41.7 29.6 l -101.9 42.7 l -103.2 -71.6 l -24.1 20.6 l -13.7 -10.5 l -104 42.7 l -21.6 6.1 l -43.1 -20.8 L 1173 188 l -101.9 42.8 l -103 -82.6 l -0.4 -0.4 l -80.3 30.9 l -62.7 -26 l -32.2 34.7 h -31.1 l -103 -113.6 l -38.6 51.9 l -0.1 -0.2 l -102.8 74.2 l -103.1 -55.1 l -47.5 50 l -15.9 -6.2 h -0.2 l -104 -26 h -0.2 l -82.6 5.6 l -59.8 -60.3 l -103 47.4 c -0.5 0.2 -0.7 0.8 -0.5 1.3 c 0.2 0.5 0.8 0.7 1.3 0.5 l 101.9 -46.7 l 57.6 58.1 l -17.4 1.2 h -0.2 l -103.5 22 c -0.5 0.1 -0.9 0.6 -0.8 1.2 c 0.1 0.5 0.6 0.9 1.2 0.8 l 103.4 -22 l 19.1 -1.3 l 45.1 45.5 l 0.1 0.1 l 0.2 0.1 l 100.5 41.5 l 0.6 0.3 l 57.6 -60.6 l 85.1 32.9 h 0.3 l 103.9 -15.1 l 63.8 -85.8 L 722.5 266 l 71 -76.6 h 71.8 l 0.2 -0.1 l 22 -8.5 l 39.7 16.5 l 104 52.5 l 0.2 0.1 h 102 l 0.2 -0.2 l 103.9 -65.4 l 81.5 -23.1 l 60.8 29.4 l 78.8 -67.3 l 88.3 67.6 l 103.2 -11.1 l 80.5 -78.9 l 62.1 -44.2 c 0.5 -0.3 0.6 -0.9 0.2 -1.4 c -0.4 -0.3 -1 -0.4 -1.5 -0.1 z M 308.7 255.3 L 209 214.1 L 165.3 170 l 80.6 -5.5 l 103.8 25.9 l 15.1 5.9 l -56.1 59 z m 246.2 -42.2 L 452.1 228 l -83.8 -32.5 l 45.9 -48.3 l 102.9 54.9 l 99.3 -71.7 l -61.5 82.7 z m 167.7 49.8 L 621.1 127.5 l 37.5 -50.4 l 101.7 112.1 l 0.3 0.3 h 30.1 l -68.1 73.4 z m 142.2 -75.4 h -69.5 l 30 -32.3 l 59.4 24.6 l -19.9 7.7 z m 371.9 -5 h -0.1 l -0.1 0.1 l -103.8 65.4 h -101 L 928 195.6 l -37.8 -15.7 l 77.2 -29.8 l 103.5 83 l 103.1 -43.2 l 102.1 -49.3 l 40.2 19.4 l -79.6 22.5 z m 142.6 5.8 l -57.6 -27.8 l 19.5 -5.5 h 0.2 l 103 -42.3 l 12.4 9.5 l -77.5 66.1 z m 269.8 -10.3 l -101.8 11 l -87.3 -66.9 l 22.6 -19.3 l 102.8 71.4 l 0.5 -0.2 l 102.6 -43 l 0.1 -0.1 l 31.5 -22.4 l -71 69.5 z M 621 317 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 z M 742 317 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 z M 863 317 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 z M 984 317 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 z M 1105 317 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 z M 1226 317 h -93 c -3.3 0 -6 2.7 -6 6 s 2.7 6 6 6 h 93 c 3.3 0 6 -2.7 6 -6 s -2.7 -6 -6 -6 z" />


                                        <rect x="522" y="317" rx="6" ry="6" width="105" height="12" />
                                        <rect x="643" y="317" rx="6" ry="6" width="105" height="12" />
                                        <rect x="764" y="317" rx="6" ry="6" width="105" height="12" />
                                        <rect x="885" y="317" rx="6" ry="6" width="105" height="12" />
                                        <rect x="1006" y="317" rx="6" ry="6" width="105" height="12" />
                                        <rect x="1127" y="317" rx="6" ry="6" width="105" height="12" />
                                    </ContentLoader>

                                </div>

                            </>


                            :
                            <>
                                <div className="metrics_card_block">
                                    {revenueTotal === null ?
                                        <label className={`metrics_card --error --1 `} style={{ cursor: 'default' }}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Revenue</p>
                                                    <h2 className="heading">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
                                                            <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                            <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                                        </svg>
                                                    </h2>
                                                    <span className="badge_item --danger"></span>

                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={revenuesIcon} alt='Helix' />
                                                    </div>
                                                    {/* <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            // checked={activeCards.includes(1)}
                                                            // onChange={() => toggleCard(1)}
                                                            className="card-checkbox"
                                                        />
                                                    </div> */}
                                                </div>
                                            </div>
                                        </label>
                                        :

                                        <label className={`metrics_card --1 active`} style={{ cursor: 'default' }}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Revenue</p>

                                                    <h2 className="heading">
                                                        ${revenueTotal?.current != null
                                                            ? formatNumber(revenueTotal.current)
                                                            : "-"}
                                                    </h2>


                                                    <span className="height_static_cls">
                                                        {comparisionOn &&
                                                            <span className={`badge_item ${getBadgeClass(revenueTotal?.percent_change ?? 0)}`}>
                                                                {revenueTotal?.difference != null
                                                                    ? `${revenueTotal.difference >= 0 ? "+" : ""}${formatNumber(revenueTotal.difference)}`
                                                                    : "-"}
                                                                <span>
                                                                    {revenueTotal?.percent_change
                                                                        ? ` (${Math.abs(revenueTotal.percent_change)})%`
                                                                        : ""}
                                                                </span>
                                                                {
                                                                    revenueTotal.difference >= 0 ?
                                                                        <img src={arrowUpIcon} alt="revenue" />
                                                                        :
                                                                        <img src={arrowDownIcon} alt="revenue" />

                                                                }

                                                            </span>
                                                        }
                                                    </span>

                                                </div>

                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={revenuesIcon} alt='Helix' />
                                                    </div>

                                                    {/* <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            // checked={activeCards.includes(1)}
                                                            // onChange={() => toggleCard(1)}
                                                            checked
                                                            disabled
                                                            className="card-checkbox"
                                                        />
                                                    </div> */}

                                                </div>

                                            </div>
                                        </label>
                                    }

                                    {requestTotal === null ?
                                        <label className={`metrics_card --error --2 `}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Total Requests</p>
                                                    <h2 className="heading"> <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
                                                        <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                        <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                                    </svg></h2>
                                                    <span className="badge_item --danger"> <span>()</span> <img src={arrowDownIcon} alt='Xerxes' /></span>
                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={requestsIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"

                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                        :
                                        <label className={`metrics_card --2 ${selectedMetrics.includes("total_requests") ? "active" : ""
                                            }`}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Total Requests</p>

                                                    <h2 className="heading">
                                                        {requestTotal?.current != null
                                                            ? formatNumber(requestTotal.current)
                                                            : "-"}
                                                    </h2>
                                                    <span className="height_static_cls">

                                                        {comparisionOn &&
                                                            <span className={`badge_item ${getBadgeClass(requestTotal?.percent_change ?? 0)}`}>
                                                                {requestTotal?.difference != null
                                                                    ? `${requestTotal.difference >= 0 ? "+" : ""}${formatNumber(requestTotal.difference)}`
                                                                    : "-"}
                                                                <span>
                                                                    {requestTotal?.percent_change
                                                                        ? ` (${Math.abs(requestTotal.percent_change)})%`
                                                                        : ""}
                                                                </span>
                                                                {
                                                                    requestTotal.difference >= 0 ?
                                                                        <img src={arrowUpIcon} alt="revenue" />
                                                                        :
                                                                        <img src={arrowDownIcon} alt="revenue" />

                                                                }
                                                            </span>
                                                        }
                                                    </span>

                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={requestsIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedMetrics.includes("total_requests")}
                                                            onChange={() => toggleMetric("total_requests")}
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    }


                                    {ecpmTotal === null ?
                                        <label className={`metrics_card --error --2 `}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">eCPM</p>
                                                    <h2 className="heading"> <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
                                                        <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                        <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                                    </svg></h2>
                                                    <span className="badge_item --danger"> <span>()</span> <img src={arrowDownIcon} alt='Xerxes' /></span>
                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={ecpmIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                        :
                                        <label className={`metrics_card --3 ${selectedMetrics.includes("ecpm") ? "active" : ""
                                            }`}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">eCPM</p>
                                                    <h2 className="heading">
                                                        ${ecpmTotal?.current != null
                                                            ? formatNumber(ecpmTotal.current)
                                                            : "-"}
                                                    </h2>
                                                    <span className="height_static_cls">

                                                        {comparisionOn &&
                                                            <span className={`badge_item ${getBadgeClass(ecpmTotal?.percent_change ?? 0)}`}>
                                                                {ecpmTotal?.difference != null
                                                                    ? `${ecpmTotal.difference >= 0 ? "+" : ""}${formatNumber(ecpmTotal.difference)}`
                                                                    : "-"}
                                                                <span>
                                                                    {ecpmTotal?.percent_change
                                                                        ? ` (${Math.abs(ecpmTotal.percent_change)})%`
                                                                        : ""}
                                                                </span>
                                                                {
                                                                    ecpmTotal.difference >= 0 ?
                                                                        <img src={arrowUpIcon} alt="revenue" />
                                                                        :
                                                                        <img src={arrowDownIcon} alt="revenue" />

                                                                }
                                                            </span>
                                                        }
                                                    </span>

                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={ecpmIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedMetrics.includes("ecpm")}
                                                            onChange={() => toggleMetric("ecpm")}
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    }


                                    {impressionTotal === null ?
                                        <label className={`metrics_card --error --2`}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Total Impressions</p>
                                                    <h2 className="heading"> <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
                                                        <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                        <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                                    </svg></h2>
                                                    <span className="badge_item --danger"> <span>()</span> <img src={arrowDownIcon} alt='Xerxes' /></span>
                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={impressionsIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                        :
                                        <label className={`metrics_card --4 ${selectedMetrics.includes("total_impressions") ? "active" : ""
                                            }`}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Total Impressions</p>
                                                    <h2 className="heading">
                                                        {impressionTotal?.current != null
                                                            ? formatNumber(impressionTotal.current)
                                                            : "-"}
                                                    </h2>
                                                    <span className="height_static_cls">

                                                        {comparisionOn &&
                                                            <span className={`badge_item ${getBadgeClass(impressionTotal?.percent_change ?? 0)}`}>
                                                                {impressionTotal?.difference != null
                                                                    ? `${impressionTotal.difference >= 0 ? "+" : ""}${formatNumber(impressionTotal.difference)}`
                                                                    : "-"}
                                                                <span>
                                                                    {impressionTotal?.percent_change
                                                                        ? ` (${Math.abs(impressionTotal.percent_change)})%`
                                                                        : ""}
                                                                </span>
                                                                {
                                                                    impressionTotal.difference >= 0 ?
                                                                        <img src={arrowUpIcon} alt="revenue" />
                                                                        :
                                                                        <img src={arrowDownIcon} alt="revenue" />

                                                                }
                                                            </span>
                                                        }
                                                    </span>

                                                </div>

                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={impressionsIcon} alt="Helix" />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedMetrics.includes("total_impressions")}
                                                            onChange={() => toggleMetric("total_impressions")}
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    }


                                    {fillrateTotal === null ?
                                        <label className={`metrics_card --error --2 `}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Fill-rate</p>
                                                    <h2 className="heading"> <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
                                                        <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                        <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                                    </svg></h2>
                                                    <span className="badge_item --danger"> <span>()</span> <img src={arrowDownIcon} alt='Xerxes' /></span>
                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={fillrateIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                        :
                                        <label className={`metrics_card --5 ${selectedMetrics.includes("fill_rate") ? "active" : ""
                                            }`}>
                                            <div className="--content">
                                                <div className="--details">
                                                    <p className="text">Fill-rate</p>
                                                    <h2 className="heading">
                                                        {fillrateTotal?.current != null
                                                            ? formatNumber(fillrateTotal.current)
                                                            : "-"}
                                                    </h2>
                                                    <span className="height_static_cls">

                                                        {comparisionOn &&
                                                            <span className={`badge_item ${getBadgeClass(fillrateTotal?.percent_change ?? 0)}`}>
                                                                {fillrateTotal?.difference != null
                                                                    ? `${fillrateTotal.difference >= 0 ? "+" : ""}${formatNumber(fillrateTotal.difference)}`
                                                                    : "-"}
                                                                <span>
                                                                    {fillrateTotal?.percent_change
                                                                        ? ` (${Math.abs(fillrateTotal.percent_change)})%`
                                                                        : ""}
                                                                </span>
                                                                {
                                                                    fillrateTotal.difference >= 0 ?
                                                                        <img src={arrowUpIcon} alt="revenue" />
                                                                        :
                                                                        <img src={arrowDownIcon} alt="revenue" />

                                                                }
                                                            </span>
                                                        }
                                                    </span>

                                                </div>
                                                <div className="--end">
                                                    <div className="--icon">
                                                        <img src={fillrateIcon} alt='Helix' />
                                                    </div>
                                                    <div className="card_checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedMetrics.includes("fill_rate")}
                                                            onChange={() => toggleMetric("fill_rate")}
                                                            className="card-checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    }
                                    {/* IVT SUNSET: IVT tile hidden from Performance metrics (data no longer returned by API). Uncomment to restore.
                                    {(props.role === "admin" || props.role === "u_admin") &&
                                        <>
                                            {ivtTotal === null ?
                                                <label className={`metrics_card --error --2 `}>
                                                    <div className="--content">
                                                        <div className="--details">
                                                            <p className="text">IVT</p>
                                                            <h2 className="heading"> <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
                                                                <path d="M0 3.328V0H10.848V3.328H0Z" fill="#020617" />
                                                                <path d="M14.75 3.328V0H25.598V3.328H14.75Z" fill="#020617" />
                                                            </svg></h2>
                                                            <span className="badge_item --danger"> <span>()</span> <img src={arrowDownIcon} alt='Xerxes' /></span>
                                                        </div>
                                                        <div className="--end">
                                                            <div className="--icon">
                                                                <img src={ivtIcon} alt='Helix' />
                                                            </div>
                                                            <div className="card_checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="card-checkbox"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                                :

                                                <label className={`metrics_card --6 ${selectedMetrics.includes("ivt") ? "active" : ""
                                                    }`}>
                                                    <div className="--content">
                                                        <div className="--details">
                                                            <p className="text">IVT</p>
                                                            <h2 className="heading">
                                                                {ivtTotal?.current != null
                                                                    ? formatNumber(ivtTotal.current)
                                                                    : "-"}
                                                            </h2>
                                                            <span className="height_static_cls">
                                                                {comparisionOn &&
                                                                    <span className={`badge_item ${getBadgeClass(ivtTotal?.percent_change ?? 0)}`}>
                                                                        {ivtTotal?.difference != null
                                                                            ? `${ivtTotal.difference >= 0 ? "+" : ""}${formatNumber(ivtTotal.difference)}`
                                                                            : "-"}
                                                                        <span>
                                                                            {ivtTotal?.percent_change
                                                                                ? ` (${Math.abs(ivtTotal.percent_change)})%`
                                                                                : ""}
                                                                        </span>
                                                                        {
                                                                            ivtTotal.difference >= 0 ?
                                                                                <img src={arrowUpIcon} alt="revenue" />
                                                                                :
                                                                                <img src={arrowDownIcon} alt="revenue" />

                                                                        }
                                                                    </span>
                                                                }
                                                            </span>

                                                        </div>
                                                        <div className="--end">
                                                            <div className="--icon">
                                                                <img src={ivtIcon} alt='Helix' />
                                                            </div>
                                                            <div className="card_checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedMetrics.includes("ivt")}
                                                                    onChange={() => toggleMetric("ivt")}
                                                                    className="card-checkbox"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            }
                                        </>
                                    }
                                    */}
                                </div>


                                {/* <Chart
                            options={chartOptions}
                            series={chartSeries}
                            type="line"
                            height={350}
                        /> */}

                                {(revenueTotal === null && requestTotal === null && ecpmTotal === null && impressionTotal === null && fillrateTotal === null && ivtTotal === null) ?
                                    <div className="chart_block_content">
                                        <div className="empty_data_icon">
                                            {/* <img src={nodataChartImg} className="w-100" alt="no-data" /> */}
                                            <img src={errorDataImg} alt="no-data" />
                                        </div>
                                    </div>
                                    :
                                    <>

                                        <Chart
                                            ref={chartRef}
                                            options={chartOptions}
                                            series={chartSeries}
                                            type="line"
                                            height={320}
                                        />
                                        <div className="custom_legend">

                                            {/* First 4: Dynamic selected metrics (lines) - solid for current, dashed for previous */}
                                            {selectedMetrics.map((metricKey) => {
                                                const color = metricColorMap[metricKey];

                                                // const label = metricKey
                                                //     .replace(/_/g, " ")
                                                //     .replace(/\b\w/g, c => c.toUpperCase());

                                                const labelRaw = metricKey
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, c => c.toUpperCase());

                                                const label = labelRaw === "Ecpm" ? "eCPM" : labelRaw;

                                                return (
                                                    <React.Fragment key={metricKey}>
                                                        <span>
                                                            <svg width="20" height="4" viewBox="0 0 20 4">
                                                                <line x1="0" y1="2" x2="20" y2="2" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
                                                            </svg>
                                                            Current {label}
                                                        </span>
                                                        {comparisionOn && (
                                                            <span>
                                                                <svg width="20" height="4" viewBox="0 0 20 4">
                                                                    <line x1="0" y1="2" x2="20" y2="2" stroke={color} strokeWidth="2.5" strokeDasharray="4 3" strokeLinecap="round" />
                                                                </svg>
                                                                Previous {label}
                                                            </span>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}

                                            {/* Last 2: Always Revenue — shown as filled dot (current) and outline dot (previous) */}
                                            <span>
                                                <svg width="10" height="10" viewBox="0 0 10 10">
                                                    <circle cx="5" cy="5" r="4.5" fill={metricColorMap.revenue} />
                                                </svg>
                                                Current Revenue
                                            </span>
                                            {comparisionOn && (
                                                <span>
                                                    <svg width="10" height="10" viewBox="0 0 10 10">
                                                        <circle cx="5" cy="5" r="4" fill="none" stroke="#E5E7EB" strokeWidth="1.5" />
                                                    </svg>
                                                    Previous Revenue
                                                </span>
                                            )}

                                        </div>

                                    </>
                                }

                            </>
                        }
                    </div>
                    <Row gutter={[16, 16]}>
                        {orderedTiles.map((key) => (
                            <React.Fragment key={key}>
                                {tileMap[key] && tileMap[key]()}
                            </React.Fragment>
                        ))}
                    </Row>
                </div>
            </div>
        </>
    )
}

export default DashboardV2Main;
